const accountUrl = '/account';

export { accountUrl };
